"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMustacheTemplate = void 0;
const mustache_1 = __importDefault(require("mustache"));
const shouldCustomizeName_1 = require("../../../shouldCustomizeName");
const CoreConfiguration_1 = __importDefault(require("../../../../../config/CoreConfiguration"));
const customizationFunctions_1 = require("./customizationFunctions");
const renderMustacheTemplate = (template, parameters) => {
    const { customFunctions } = CoreConfiguration_1.default.getInstance().customMustacheFunctionsBuilder;
    const mustacheView = {
        ...parameters,
        orderRu1: customizationFunctions_1.orderRu1,
        orderRu2: customizationFunctions_1.orderRu2,
        orderRu3: customizationFunctions_1.orderRu3,
        pluralRu1: customizationFunctions_1.pluralRu1,
        pluralRu2: customizationFunctions_1.pluralRu2,
        pluralRu3: customizationFunctions_1.pluralRu3,
        scoreFn: customizationFunctions_1.scoreFn,
        withParentheses: customizationFunctions_1.withParentheses,
        withPlus: customizationFunctions_1.withPlus,
    };
    if (customFunctions) {
        Object.assign(mustacheView, customFunctions);
    }
    return mustache_1.default.render(template, mustacheView, {}, shouldCustomizeName_1.templateTags);
};
exports.renderMustacheTemplate = renderMustacheTemplate;
//# sourceMappingURL=renderMustacheTemplate.js.map